import { useTranslation } from 'react-i18next';
import './index.scss';

type CancerDetailProps = {
  details: { labelKey: string; displayValue: string; testId?: string }[];
  testId?: string;
};

const SEPARATOR = ':';

function CancerDetails({ details, testId }: CancerDetailProps) {
  const { t } = useTranslation();

  return (
    <ul className="cancer-details-list" data-testid={testId}>
      {details.map((detail) => (
        <li key={detail.labelKey} className="cancer-details-list__item" data-testid={detail.testId}>
          <span className="cancer-details-list__label">{`${t(detail.labelKey)}${SEPARATOR}`}</span>
          <span className="cancer-details-list__value">{t(detail.displayValue)}</span>
        </li>
      ))}
    </ul>
  );
}

export default CancerDetails;
